import { useSyncExternalStore } from "react"

import {
  currentOutage,
  isCheckingOutage,
  subscribeToOutage,
  type Outage,
} from "@/lib/api/outage"

export function useOutage(): { outage: Outage | null; isChecking: boolean } {
  const outage = useSyncExternalStore(subscribeToOutage, currentOutage)
  const isChecking = useSyncExternalStore(subscribeToOutage, isCheckingOutage)

  return { outage, isChecking }
}
